export const MOTION_MINI_SELECTION_STORAGE_PREFIX = 'cartographer:motion-pip:v1';
export const ASSET_LIBRARY_VALUE_PREFIX = 'library:';
export const ENABLE_DOCKED_MINI_MOTION_PREVIEW = true;
export const ENABLE_STAGE_MOTION_PREVIEW = true;
// When false, skip localStorage read/write for last-picked motion (avoids load-time churn).
export const ENABLE_MOTION_SELECTION_PERSISTENCE = false;

/**
 * In-scene motion preview footer: timeline bar sizing and placement.
 * Central place to tweak the strip, padding, and slider row.
 */
export const MOTION_SCENE_PREVIEW_TIMELINE = {
  /** Max width of the timeline card (px). */
  maxWidthPx: 1200,
  /** Initial `calc(100vw - X)` inset; drag resize can still expand to the max edge gutter. */
  defaultHorizontalViewportGutterPx: 160,
  /** Max `calc(100vw - X)` inset so the bar matches side-panel edge spacing. */
  horizontalViewportGutterPx: 72,
  paddingX: 12,
  paddingY: 6,
  /** Space between the label block, track, and actions. */
  gap: 5,
  /** Corner radius of the card (px); maps to ~rounded-xl. */
  borderRadius: 12,
  /** “Motion name” line clamp width. */
  labelMaxWidthPx: 260,
  /** Row height for the playhead row and loading/error row (px). */
  rowHeightPx: 22,
  /** Per-digit width used for the frame counter min width. */
  frameCounterChWidthPx: 14,
  /**
   * Extra class on the Slider root (e.g. tighten vertical chrome). Merges with Slider defaults.
   * Track thickness is the Slider `size` prop (sm = thin).
   */
  sliderRootClassName: '!h-4',
} as const;

/**
 * Layering treatment for the Stage timeline when it overlaps other glass panels.
 * Keep each layer independently switchable so we can tune contrast without
 * changing the timeline footprint.
 */
export const MOTION_SCENE_PREVIEW_LAYERING = {
  enableBottomScrim: false,
  enableDockPlate: false,
  enableElevatedCardSurface: true,
  bottomScrimClassName:
    'pointer-events-none absolute inset-x-0 -bottom-4 h-28 bg-gradient-to-t from-gray-90/18 via-gray-90/8 to-transparent dark:from-black/32 dark:via-black/12',
  dockPlateClassName:
    'pointer-events-none absolute inset-x-0 -top-1 -bottom-1 mx-auto w-full rounded-2xl bg-gray-90/8 shadow-menu backdrop-blur-sm dark:bg-black/12',
  cardBaseClassName:
    'mx-auto flex w-full flex-col lg:flex-row lg:items-center',
  cardDefaultSurfaceClassName: 'bg-primary shadow-md',
  cardElevatedSurfaceClassName:
    'bg-gray-15/55 shadow-menu backdrop-blur-md dark:bg-gray-90/45',
} as const;

/**
 * Mini preview card wrapper: same frosted + translucent frame as
 * `WorkspaceLayout/FloatingPanel` when open (inspector / outliner).
 * Keep in sync with `panelSurfaceClassName` there.
 */
export const MOTION_MINI_FROSTED_FRAME_CLASS =
  'bg-gray-15/45 dark:bg-gray-90/40 shadow-menu overflow-hidden rounded-xl';

/**
 * 150px preview slot when the 3D canvas is not shown: softer glass so the card
 * reads as "waiting for viewer" rather than a solid panel.
 */
export const MOTION_MINI_VIEWPORT_PLACEHOLDER_CLASS =
  'bg-white/20 dark:bg-gray-90/25 backdrop-blur-sm';
